module.exports = __webpack_public_path__ + "04_glasses_black.70b71e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/04_glasses_black.png
// module id = Orlf
// module chunks = 0